import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { cardDetailResModel } from 'src/app/home/models/cardBalanceResponse.model';
import { virtualCardsResModel } from 'src/app/home/models/favoriteResponse.model';
import { BalanceService } from 'src/app/home/services/cardBalance.service';
import { SliderService } from '../../utility-classes/slider/slider.service';
import { CardBalanceState } from '../utility-classes/card-balance-state';

@Component({
  selector: 'app-nfc',
  templateUrl: './nfc.component.html',
  styleUrls: ['./nfc.component.scss']
})
export class NfcComponent extends CardBalanceState implements OnInit {
  @Input() item!: virtualCardsResModel;
  @Input() index!: number;

  card!:cardDetailResModel;

  private subscription = new Subscription();

  constructor(
    protected store: Store,
    private slider: SliderService
  ) { 
    super(store);
  }

  ngOnInit(): void {
    this.subscription.add(
      this.slider.getActiveCards$().subscribe(index => {
        if(index == this.index){
          this.getCardBalanceIfNotExist(this.item.alias);
        }
      })
    );
    
    this.loadCardBalance$(this.item.alias).subscribe(card => {
      this.card = card!;
    });
  }

  get alias(){
    return Number(this.item.alias);
  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
    this.unsubscribeFromStore();
  }

}
